/**
 * Created by Josef Jurca on 14.5.2018.
 */

import {ActionTypes, LandingPageStatuses} from '../actions/landing';

const defaultState = {
    landingPage: {},
    currentLandingPage: {},
    status: LandingPageStatuses.INITIAL,
    error: ''
};

/**
 * Returns the set landing page state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function landingPage (state = {}, action) {

    switch (action.type) {
        case ActionTypes.SET_LANDING_PAGE:

            return Object.assign({}, state, action.landingPage);

        default:
            return state;
    }
}

/**
 * Returns the set current landing page state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function currentLandingPage (state = {}, action) {

    switch (action.type) {
        case ActionTypes.SET_CURRENT_LANDING_PAGE:

            return Object.assign({}, state, action.currentLandingPage);

        default:
            return state;
    }
}

/**
 * Returns the landing page status state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function status (state = LandingPageStatuses.REQUEST_OPEN, action) {

    switch (action.type) {

        case ActionTypes.LANDING_PAGE_SET_STATUS:
            return (state = action.status);

        default:
            return state;
    }
}

/**
 * Returns the linear channels error state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function error (state = '', action) {

    switch (action.type) {

        case ActionTypes.LANDING_PAGE_SET_ERROR:
            return (state = action.error || '');

        default:
            return state;
    }
}

/**
 * Returns landing page state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function (state = defaultState, action) {
    return {
        landingPage: landingPage(state.landingPage, action),
        currentLandingPage: currentLandingPage(state.currentLandingPage, action),
        status: status(state.status, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/landing.js